module.exports = __webpack_public_path__ + "static/media/studio-etc1.d0f3f2b6.png";